import { remoteLogMessage } from '@gjensidige/service-error-handler';

import { daysWithLabelAndValue } from '../constants/texts';
import { CallMeFormState, QueueDetailsType, TimeslotOption } from '../types';

export const logInfoMessage = (message: string) => {
  if (window.location.hostname === 'localhost') {
    console.log(message);
  } else {
    remoteLogMessage(message, { severity: 'INFO' });
  }
};

export const isDefined = <T>(arg: T | undefined | null): arg is T => !!arg;

const getDayIndex = (
  daysOptions: { label: string; value: number; dateValue: Date }[],
  todayDay: number
) => {
  const findNextIndex = (day: number): number => {
    const index = daysOptions.findIndex((d) => d.value === day);
    if (index !== -1) {
      return index;
    } else {
      const nextDay = day + 1 < 6 ? day + 1 : 0;
      return findNextIndex(nextDay);
    }
  };

  return findNextIndex(todayDay);
};

export const getSortedDaysOptions = (
  days: typeof daysWithLabelAndValue,
  date: Date,
  arrayOfDates: string
) => {
  const todayDay = date.getDay();

  const daysOptions = Object.values(days)
    .map((data: { label: string; value: number }) => {
      const dayDate = new Date(date);
      dayDate.setDate(dayDate.getDate() + ((data.value - todayDay + 7) % 7));
      if (
        arrayOfDates &&
        arrayOfDates.includes(dayDate.toLocaleDateString('sv-SE'))
      ) {
        return null;
      }
      return data.value === todayDay
        ? { ...data, label: 'I dag', dateValue: dayDate }
        : { ...data, dateValue: dayDate };
    })
    .filter(isDefined);
  const todayIndex = getDayIndex(daysOptions, todayDay);
  const reorderedDayOptions = daysOptions
    .slice(todayIndex)
    .concat(daysOptions.slice(0, todayIndex));
  const limitedDayOptions = reorderedDayOptions.slice(0, 4);
  return limitedDayOptions;
};

export const getTimeslotOptions = (
  open: number,
  close: number,
  day: number,
  today: Date,
  lunchBreak: string
): TimeslotOption[] => {
  const options: TimeslotOption[] = [];
  const currentHour = today.getHours();
  const currentDay = today.getDay();
  const isToday = today.getDay() === day;
  const daysInTheFuture =
    day >= currentDay ? day - currentDay : 7 - currentDay + day;
  const [breakStart, breakEnd] = lunchBreak
    .split('-')
    .map((n: string) => Number(n));
  for (let i = open; i < close; i++) {
    const startTime = i;
    const endTime = i + 1;
    const startDate = new Date(Date.now());
    startDate.setDate(startDate.getDate() + daysInTheFuture);
    startDate.setHours(startTime, 0, 0, 0);

    const endDate = new Date(Date.now());
    endDate.setDate(endDate.getDate() + daysInTheFuture);
    endDate.setHours(endTime, 0, 0, 0);

    if (startDate.getHours() > currentHour || !isToday) {
      if (startTime < breakStart || startTime >= breakEnd) {
        options.push({
          label: `${startTime}:00–${endTime}:00`,
          value: startDate
        });
      }

      // options.push({
      //   label: `${startTime}:30–${endTime}:00`,
      //   value: endDate
      // });
    }
  }
  return options;
};

export const addCallbackTimeslot = (date: Date) => {
  if (date) {
    const newDate = new Date(date);
    newDate.setMinutes(Math.floor(date.getMinutes()));
    return newDate;
  }
  return '';
};

function formatPhoneNumber(number: string): string {
  let result;
  if (number.length === 10 && number.charAt(0) === '0') {
    result = '+46' + number.substring(1);
  } else {
    result = '+46' + number;
  }

  return result;
}

export const preparePayload = (
  contactFormData: CallMeFormState,
  queDetails: QueueDetailsType,
  isScheduledCall: boolean
) => {
  const ringMeDate =
    isScheduledCall && contactFormData.time
      ? addCallbackTimeslot(contactFormData.time?.value)
      : null;
  return {
    phoneNumber: contactFormData.number.startsWith('+46')
      ? contactFormData.number
      : formatPhoneNumber(contactFormData.number),
    customerName: contactFormData.name,
    comment: `Is Customer: ${contactFormData.isCustomer}, Name: ${contactFormData.name}`,
    errand: queDetails.errand,
    entrance: queDetails.entrance,
    menuchoice: queDetails.menuchoice,
    ...(isScheduledCall && {
      startTime: ringMeDate ? ringMeDate.toISOString() : ''
    })
  };
};
